// Module
var code = "<div class=\"tasks\">\n  <section class=\"content-header tabs\" layout=\"row\" layout-align=\"start center\">\n    <div\n      class=\"content-tabs\"\n      disable-while-editing\n      tab-views\n      data=\"vm.contentTabs\"\n    ></div>\n  </section>\n  <div ui-view></div>\n</div>\n";
// Exports
module.exports = code;